// Route path constants only — import from here (not screen modules) to keep lazy chunks small.

export const AdminStackName = "/AdminStack";
export const LoginStackName = "/LoginStack";
export const ClientStackName = "/ClientStack";

export const MainScreenName = "/MainScreen";
export const TaggedCasesScreenName = "/TaggedCasesScreen";
export const AllCasesScreenName = "/AllCasesScreen";
export const AllClientsScreenName = "/AllClientsScreen";
export const MyCasesScreenName = "/MyCases";
export const AllMangerScreenName = "/AllManger";
export const FirmStaffRolesScreenName = "/FirmStaffRoles";
export const AllCasesTypeScreenName = "/AllCasesType";
export const SigningManagerScreenName = "/SigningManagerScreen";
export const SigningSpotsPreviewScreenName = "/SigningSpotsPreview/:signingFileId";
export const uploadFileForSigningScreenName = "/UploadFileForSigningScreen";
export const EvidenceDocumentsScreenName = "/EvidenceDocumentsScreen";
export const PlanUsageScreenName = "/PlanUsage";
export const PlansPricingScreenName = "/PlansPricing";
export const RemindersScreenName = "/RemindersScreen";
export const PlatformSettingsScreenName = "/PlatformSettingsScreen";
export const OfficeIntegrationsScreenName = "/OfficeIntegrations";
export const AdminSupportScreenName = "/support";
export const CalendarScreenName = "/CalendarScreen";
export const DailyAgendaScreenName = "/calendar/day/:date";
export const CalendarInviteScreenName = "/calendar-invite/:token";
export const ShortNavRedirectScreenName = "/n/:slug";

export const ClientMainScreenName = "/ClientMainScreen";
export const ClientCasesScreenName = "/ClientCasesScreen";
export const ClientDocumentsScreenName = "/ClientDocumentsScreen";
export const ClientSignedDocumentsScreenName = "/ClientSignedDocumentsScreen";
export const SigningScreenName = "/SigningScreen";
export const NotificationsScreenName = "/Notifications";
export const ProfileScreenName = "/ProfileScreen";
export const ClientTicketScreenName = "/TicketScreen";

export const LoginScreenName = "/LoginScreen";
export const LoginOtpScreenName = "/LoginOtpScreen";

export const BrowserSigningScreenName = "/ViewSignedDocument/Signing";
export const BrowserSigningLinkScreenName = "/ViewSignedDocument/Link/:slug";
export const PublicSignScreenName = "/PublicSignScreen";
export const ShortSignRedirectScreenName = "/s/:slug";
export const ViewSignedDocumentName = "/ViewSignedDocument";
export const EvidenceVerifyScreenName = "/Verify/Evidence/:signingFileId";
export const PricingScreenName = "/Pricing";
export const SecurityScreenName = "/SecurityScreen";
export const PrivacyPageName = "/Privacy";
export const ContinuityPageName = "/Continuity";
export const CompliancePageName = "/Compliance";
export const ChatBotPageName = "/ChatBot";
